import Vue from 'vue'
import Router from 'vue-router'
import IndexPage from '@/components/Index'
import HearingQuestions from '@/components/HearingTest/HearingQuestions'
import HearingCalibration from '@/components/HearingTest/HearingCalibration'
import HearingPureToneTest from '@/components/HearingTest/HearingPureToneTest'
import HearingSpeechTest from '@/components/HearingTest/HearingSpeechTest'
import HearingShowResult from '@/components/HearingTest/HearingShowResult'

Vue.use(Router)

export default new Router({
    routes: [
        {
          path: '/',
          name: 'IndexPage',
          component: IndexPage
        },
        {
            path: '/hearing-questions',
            name: 'HearingQuestions',
            component: HearingQuestions
        },
        {
          path: '/hearing-calibration',
          name: 'HearingCalibration',
          component: HearingCalibration
        },
        {
            path: '/pure_tone_test',
            name: 'HearingPureToneTest',
            component: HearingPureToneTest
        },
        {
            path: '/speech_test',
            name: 'HearingSpeechTest',
            component: HearingSpeechTest
        },
        {
            path: '/show_result',
            name: 'HearingShowResult',
            component: HearingShowResult
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js